import { C8NodeType } from "src/c8-platform/type/node";

const DEFAULT_CUSTOM_VIEW_CONTAINER_PREFIX = "TYPE";
const DEFAULT_CUSTOM_VIEW_CONTAINER_GROUPED = "Grouped";

export const ATTR_PATH_HINTS = "PathHints";

/** return container key to use for a view with the given type, subtype and path hints */
export function getCustomViewContainerKeyForType(nodeType: C8NodeType, subtypeName?: string, pathHints?: string, grouped?: boolean): string {
	const parts = [DEFAULT_CUSTOM_VIEW_CONTAINER_PREFIX, nodeType];

	if (pathHints) {
		parts.push(subtypeName || "");
		parts.push(pathHints);
	} else if (subtypeName) {
		parts.push(subtypeName);
	}

	if (grouped) {
		parts.push(DEFAULT_CUSTOM_VIEW_CONTAINER_GROUPED);
	}

	return parts.join("/");
}

/** return true if given key is a custom view container for views of a fixed type */
export function isCustomViewContainerTypeKey(key: string): boolean {
	return key.startsWith(`${DEFAULT_CUSTOM_VIEW_CONTAINER_PREFIX}/`);
}